import { Component, OnInit } from '@angular/core';


export class ChLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ch-loading',
  template: "\n    <div class=\"ch-ui-loading\"><div class=\"ch-ui-rotate\"><span class=\"spinner\"></span><div class=\"load-message\">Loading……</div></div></div>\n  ",
  styles: ["\n    .ch-ui-loading{width:100%;height:100%;position:fixed;top:0;left:0;background:rgba(0,0,0,0.7);z-index:999;cursor:wait}.ch-ui-loading .ch-ui-rotate{position:absolute;top:40%;left:0px;right:0px}.ch-ui-loading .ch-ui-rotate .spinner{margin:0px auto;transition:margin .2s ease-in,opacity .4s ease-in;font-family:sans-serif;font-weight:100;-webkit-animation:three-quarters 1.25s infinite linear;animation:three-quarters 1.25s infinite linear;border-top:1.1em solid rgba(255,255,255,0.2);border-right:1.1em solid rgba(255,255,255,0.2);border-left:1.1em solid #00abff;border-bottom:1.1em solid rgba(255,255,255,0.2);border-radius:100%;box-sizing:border-box;display:block;overflow:hidden;text-indent:-9999px;width:10em;height:10em}.ch-ui-loading .ch-ui-rotate .spinner :not{margin-left:-22px;opacity:0;transition:margin .4s ease-out,opacity .2s ease-out}.ch-ui-loading .ch-ui-rotate .load-message{font-size:1.3em;text-align:center;color:#fff}@-webkit-keyframes three-quarters{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes three-quarters{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}\n  "]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
